import { useEffect, useRef } from "react";
import { Button } from "../../components/Button";
import "./TourPreviewNotice.css";

interface TourPreviewNoticeProps {
  message: string;
  onDismiss: () => void;
}

/**
 * Why a requested preview is not on screen.
 *
 * Without it a system admin clicks "Preview on the web app", lands on a page where nothing happens,
 * and has no way to tell a draft with no steps from an endpoint this server does not have.
 */
export const TourPreviewNotice = ({ message, onDismiss }: TourPreviewNoticeProps) => {
  const noticeRef = useRef<HTMLDivElement>(null);

  // It renders after the page's own content, so it is the last tab stop. Focus goes to it instead,
  // which is also how the admin gets from "nothing happened" to Dismiss without hunting.
  useEffect(() => {
    noticeRef.current?.focus();
  }, []);

  return (
    <div
      ref={noticeRef}
      tabIndex={-1}
      className="tour-preview-notice"
      role="alert"
      data-testid="tour-preview-notice"
    >
      <p className="tour-preview-notice__message">{message}</p>
      <Button
        type="button"
        variant="secondary"
        onClick={onDismiss}
        data-testid="tour-preview-notice-dismiss"
      >
        Dismiss
      </Button>
    </div>
  );
};
